const validate = values => {
  const errors = {}

  // domain required
  if (!values.domain) {
    errors.domain = "Required"
  }

  return errors
}

export default (validate)